import { Shadow } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Box, FlatList } from 'native-base';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import { Empty } from '../../../../../BatchTicket/components/Cart/components/Empty';
import { flatListProps } from '../../../../utils';
import { Separator } from '../../../Separator';

import { Item } from './components/Item';
import { data } from './data';

interface MyConsortiumsProps {}

export const MyConsortiums: React.FC<MyConsortiumsProps> = () => {
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();

  const dataIsEmpty = data.length === 0;

  const handlePress = (item: (typeof data)[0]) => {
    navigation.navigate('MyConsortiumDetails', item);
  };

  if (dataIsEmpty) {
    return (
      <Box h="580px" w="full">
        <Empty
          title="Este cliente ainda nao possui nenhum consórcio."
          description={'Para enviar recomendações de consórcios para seus clientes, clique em'}
          buttonTitle="SIMULAR CONSÓRCIO."
          onPressButton={() => console.log('Simular consorcio')}
        />
      </Box>
    );
  }

  return (
    <Shadow level={1} w="full" borderRadius={BoxRadius.sm}>
      <FlatList
        {...flatListProps}
        maxH="580px"
        data={data}
        ItemSeparatorComponent={Separator}
        keyExtractor={(item) => item.id.toString()}
        renderItem={({ item }) => <Item item={item} onPress={() => handlePress(item)} />}
      />
    </Shadow>
  );
};
